import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import './EventDetailPage.css';

const EventDetailPage = ({ events }) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const event = events.find(e => e.id === parseInt(id));

  if (!event) {
    return <div>이벤트를 찾을 수 없습니다.</div>;
  }

  return (
    <div className="event-detail-page">
      <div className="event-detail-header">
        <button className="back-button" onClick={() => navigate(-1)}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M15 18l-6-6 6-6" />
          </svg>
        </button>
        <h2>이벤트 상세 정보</h2>
      </div>
      <div className="event-detail-content">
        <div className={`event-banner ${event.genre?.toLowerCase()}`}>
          {event.poster_image_url && <img src={event.poster_image_url} alt={event.title} className="event-banner-background"/>}
          <h3>{event.title}</h3>
        </div>
        <div className="event-info">
          <div className="info-row">
            <span className="info-label">장르</span>
            <span className={`info-value genre-tag ${event.genre}`}>{event.genre}</span>
          </div>
          <div className="info-row">
            <span className="info-label">날짜</span>
            <span className="info-value">{event.date}</span>
          </div>
          <div className="info-row">
            <span className="info-label">시간</span>
            <span className="info-value">{event.time}</span>
          </div>
          <div className="info-row">
            <span className="info-label">장소</span>
            <span className="info-value">{event.location}</span>
          </div>
          <div className="info-row description">
            <span className="info-label">상세설명</span>
            <p className="info-value">{event.description}</p>
          </div>
        </div>
        {/* Actions removed for now, can be added back for admins
        <div className="event-actions">
          <button className="edit-button">수정하기</button>
          <button className="delete-button" onClick={handleDelete}>삭제하기</button>
        </div>
        */}
      </div>
    </div>
  );
};

export default EventDetailPage; 